export function markAttendance(sessionId, regno) {
  const key = `attendance_${sessionId}`;
  const existing = JSON.parse(localStorage.getItem(key) || "[]");

  if (existing.some(e => e.regno === regno)) {
    return "already_marked";
  }

  existing.push({
    regno,
    time: new Date().toISOString(),
    source: "student"
  });

  localStorage.setItem(key, JSON.stringify(existing));
  return "stored";
}
